import { getTabTool, patchTask } from '@fno/service/api/tasks.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/hello/task/helpers.js'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import tabToolSchema from 'fanx-schema/resource/taskTabTool'
import template from './DeveloperAccount.svelte'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    clientOnboarding: {
        type: Object,
        schema: tabToolSchema,
        patch: (task) => patchTask({ task })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.developerAccount`

    stateRouter.addState({
        name,
        route: '/developerAccount',
        template,
        data: {
            title: 'Developer Account | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ clientOnboarding ] = await Promise.all([
                getTabTool({ schoolId })
            ])

            return setContextOriginal(
                {
                    context: {
                        form: {
                            clientOnboarding: transformApiResponseToFormObject({
                                schema: tabToolSchema,
                                data: clientOnboarding
                            })
                        }
                    }
                },
                preFormMutator
            )
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'DEVELOPER_ACCOUNT',
                nextId: 'appIcons'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'affiliations', schoolId))
            component.$on('save', save)
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
        }
    })
}
